export default function useQuery(useLocation) {
  return new URLSearchParams(useLocation().search);
}
